define('user/user.module',['angular', './user.routes', './user.controllers', './user.services'], function(angular, routes, controllers) {
    'use strict';
    var mod = angular.module('com.cd.user', ['ngRoute', 'user.routes', 'user.services']);
    mod.controller('SetSMSCtrl', controllers.SetSMSCtrl);
    mod.controller('SelectOrgCtrl', controllers.SelectOrgCtrl);
    mod.controller('PwUpdateCtrl', controllers.PwUpdateCtrl);
    return mod;
});
